/*
 * @Author: 肖玲
 * @Date: 2023-02-23 18:21:00
 * @LastEditTime: 2023-03-06 15:48:34
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\earlywarning-manage\early-warning-platform\modules\earlywarningInformationManageRouter.js
 * 预警信息管理路由
 */
const earlywarningInformationManageRouter = [
  // 预警信息
  {
    path: '/earlywarning-manage/early-warning-platform/earlywarning-information-manage/earlywarning-info/Page',
    name: 'EarlywarningInfo',
    component: () =>
      import(
        /*webpackChunkName:"doctorDataKpi" */
        '@/views/earlywarning-manage/early-warning-platform/earlywarning-information-manage/earlywarning-info/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '预警信息管理', //二级菜单
      title: '预警信息',
    },
  },
  // 预警信息  详情
  {
    path: '/earlywarning-manage/early-warning-platform/earlywarning-information-manage/earlywarning-info/Detail/:id',
    name: 'EarlywarningInfoDetail',
    component: () =>
      import(
        /*webpackChunkName:"doctorDataKpi" */
        '@/views/earlywarning-manage/early-warning-platform/earlywarning-information-manage/earlywarning-info/Detail.vue'
      ), //
    meta: {
      SecondaryMenu: '预警信息管理', //二级菜单
      title: '预警详情',
      breadcrumb: [{
        title: '预警信息',
        name: 'EarlywarningInfo',
      }, ],
    },
  },

  // 预警报表
  {
    path: '/earlywarning-manage/early-warning-platform/earlywarning-information-manage/earlywarning-report/Page',
    name: 'EarlywarningReport',
    component: () =>
      import(
        /*webpackChunkName:"doctorDataKpi" */
        '@/views/earlywarning-manage/early-warning-platform/earlywarning-information-manage/earlywarning-report/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '预警信息管理', //二级菜单
      title: '预警统计',
    },
  },
]
export default earlywarningInformationManageRouter